var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPaymentStatusSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 50,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25,
  r: 25,
  fill: "#D8F1E7"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25,
  r: 12,
  fill: "#1EBF7C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M24.666 29.25a.81.81 0 0 0 .723-.384l4.937-7.843a.96.96 0 0 0 .174-.536.71.71 0 0 0-.733-.737c-.296 0-.475.108-.654.4l-4.468 7.27-2.29-2.98c-.173-.222-.353-.32-.611-.32a.72.72 0 0 0-.744.748c0 .19.063.369.216.558l2.733 3.456c.2.254.422.368.717.368",
  clipRule: "evenodd"
})));
export default SvgIconPaymentStatusSuccess;